import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { LWAReason } from 'src/app/admin/lwa-reasons/shared/models/left-without-assistant-reasion.model';
import { LWAReasonService } from 'src/app/admin/lwa-reasons/shared/services/left-without-assistant-reasons.service';
import { LWAModel } from 'src/app/lobby/lobby-central-views/shared/models/lwa-model';
import { LobbyEntryService } from 'src/app/lobby/shared/services/lobby-entry.service';
import { LobbyService } from 'src/app/lobby/shared/services/lobby.service';
import { getLobbyLocationSelected, getLoggedInUserId } from 'src/app/state';
import { State } from 'src/app/state/app.state';

@Component({
  selector: 'app-left-without-assistance',
  templateUrl: './left-without-assistance.component.html',
  styleUrls: ['./left-without-assistance.component.scss']
})
export class LeftWithoutAssistanceComponent implements OnInit, OnDestroy {
  @Input() public selectedLWAResons: any = null;
  @Input() public allLWAResons: LWAReason[] = [];
  @Input() public dialogOpened: boolean = false;
  @Input() public lwaObject: LWAModel = {
    firstName: '',
    lastName: '',
    locationName: ''
  };
  @Input() public dataItem: any;
  public signedInLocationId: number = 0;
  leftWithoutAssistanceSubscriptions = new Subscription();
  public comment: string = '';
  constructor(public lwaService: LWAReasonService,
    public lobbyEntryService: LobbyEntryService,
    public lobbyService: LobbyService,
    private store: Store<State>) { }

  ngOnInit() {
    const signedInlocationSub = this.store.select(getLobbyLocationSelected).subscribe(
      (location) => {
        if (location.locationId != null) {
          this.signedInLocationId = location.locationId;
        }
      }
    );
    this.leftWithoutAssistanceSubscriptions.add(signedInlocationSub)
  }

  public close() {
    this.selectedLWAResons = null;
    this.dialogOpened = false;
  }

  public open(component?: any) {
    this.lobbyService.getLwaReasonsForLobby().subscribe((allLWAs) => {
      this.allLWAResons = allLWAs;
      this.selectedLWAResons = this.allLWAResons[0];
      this.dialogOpened = true;
    })

  }

  /**
 * Submits the "Left Without Assistant" reason and related data.
 * Fetches the logged-in user ID from the store and calls the `setLWAReason` API.
 * Resets the comment and unsubscribes from the user ID subscription upon success.
 */
  public submitLeftWithoutAssistant() {
    const getLoggedInUserSub = this.store.select(getLoggedInUserId)
      .subscribe((userId?: number) => {
        this.lobbyEntryService.setLWAReason(this.dataItem.lobbyEntryId,
          this.signedInLocationId,
          Number(this.selectedLWAResons.id),
          this.comment, userId).subscribe((data) => {
            this.close();
            this.comment = '';
            getLoggedInUserSub.unsubscribe();
          });
      });
  }

  checkedChange(i: number) {
    this.selectedLWAResons = this.allLWAResons[i];
  }

  ngOnDestroy(): void {
    this.leftWithoutAssistanceSubscriptions.unsubscribe();
  }
}
